export default __webpack_public_path__ + "static/media/thebeerspotimage.3f90bba9.jpg";